<template>
    <div class="white-sidebar">
        <div class="menu-left-sketch">
            <div class="menu-items">
                <div>
                    <p class="title">ÎNCEPEM AICI</p>
                    <ul>
                        <router-link class="item" to="/aplicatii/m3-sketch/imm-recover">IMM Recover
                            <img v-if="completePages && completePages.includes('imm-recover')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" :to="{ name: 'CompaniaMea' }">Compania mea
                            <img v-if="completePages && completePages.includes('compania-mea')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/proiectul-meu">Proiectul meu
                            <img v-if="completePages && completePages.includes('proiectul-meu')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/checklist">Checklist
                            <img v-if="completePages && completePages.includes('checklist')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/activitati">Activități
                            <img v-if="completePages && completePages.includes('activitati')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/obiective">
                            Obiective
                            <img v-if="completePages && completePages.includes('obiective')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/indicatori">Indicatori
                            <img v-if="completePages && completePages.includes('indicatori')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                    </ul>
                </div>
                <div class="menu-items">
                    <p class="title">BUGET ȘI ACTIVITĂȚI</p>
                    <ul>
                        <router-link class="item" to="/aplicatii/m3-sketch/achizitii-cheltuieli">Achiziții / cheltuieli
                            <img v-if="completePages && completePages.includes('achizitii-cheltuieli')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/buget">Bugetul proiectului
                            <img v-if="completePages && completePages.includes('buget')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/plan-de-afaceri">Planul de afaceri
                            <img v-if="completePages && completePages.includes('plan-de-afaceri')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/cerere-de-finantare">Cerere de finanțare
                            <img v-if="completePages && completePages.includes('cerere-de-finantare')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>

                    </ul>
                </div>
                <div class="menu-items">
                    <p class="title">DOSARUL TĂU FINAL</p>
                    <ul>
                        <router-link class="item" to="/aplicatii/m3-sketch/sinteza">Sinteză proiect
                            <img v-if="completePages && completePages.includes('sinteza')" src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                        </router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/dosarul-tau">Dosarul tău complet</router-link>
                    </ul>
                </div>
                <div class="menu-items">
                    <p class="title">UTILE</p>
                    <ul>
                        <router-link class="item" to="/aplicatii/m3-sketch/intrebari-frecvente">Întrebări frecvente</router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/tichete-suport">Deschide un tichet</router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/documente-utile">Documente utile</router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/notificari">Notificări</router-link>
<!--                        <router-link class="item" to="/aplicatii/m3-sketch/tutorial-aplicare">Tutorial de aplicare</router-link>
                        <router-link class="item" to="/aplicatii/m3-sketch/achizitii-verzi">Achiziții verzi <img src="@/assets/images/M3/M3Sketch/procentMediu.png" alt="Procent de mediu" title="Contribuția cheltuielii la obiectivele de mediu" style="width: 13px; height: 16px; margin-left: 6px;"></router-link>-->
                    </ul>
                </div>
<!--                <div class="menu-items">
                    <p class="title">RAPORTEAZĂ O PROBLEMĂ</p>
                    <ul>
                        <router-link class="item" to="/aplicatii/m3-sketch/tichete-suport">Problemă aplicație</router-link>
                    </ul>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            companiesLength: [],
        },
        computed: {
            completePages: function () {
                return this.$store.getters['pages/completed'];
            }
        }
    }
</script>

<style scoped>
.white-sidebar{
    width: 100%;
    max-width: 194.5px;
    background: #fff;
    padding: 10px 0 30px 0;
    min-height: 100%;
}
.center{
    text-align: center;
}
.menu-left-sketch{
    height: calc(100vh - 110px);
    overflow-y: auto;
    width: 100%;
    overflow-x: hidden;
}
.menu-left-sketch > .menu-items{
	padding-bottom: 15px;
}
.center img{
    max-width: 160px;
}
ul{
    list-style: none;
}
.title{
    font-size: 9px;
    color: #aeaeae;
    padding-bottom: 10px;
    padding-left: 23px;
}
.margin-top{
    margin-top: 38px;
}
.item{
    font-size: 12px;
    padding-left: 23px !important;
    color: #826d8a;
    font-weight: 500;
    margin: 0 3px 3px 3px;
    position: relative;
    border-radius: 2px;
    width: 100%;
    padding: 4px 8px;
    display: flex;
    max-width: 190px;
}
.checked-icon{
    position: absolute;
    left: 6px;
    top: 9px;
}
a:hover{
    background: #e4e5e8;
}
.router-link-active{
    background: #e4e5e8;
}
a:hover{
    text-transform: none;
    text-decoration: none;
}
.dashboard-button{
    background: #49cda8;
    color: #fff;
    margin-top: 38px;
}
.dashboard-button:hover{
    background: #3cb492;
}
</style>
